import { BrowserModule } from '@angular/platform-browser';
import {APP_INITIALIZER, ApplicationRef, DoBootstrap, ErrorHandler, Injector, LOCALE_ID, NgModule} from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {DxCoreModule} from "./dx-core/dx-core.module";
import {APP_BASE_HREF, CurrencyPipe, HashLocationStrategy, LocationStrategy} from "@angular/common";
import {environment} from "../environments/environment";
import {DxErrorHandler} from "./dx-core/services/dx-error-handler.service";
import {DxInMemoryBackendModule} from "./dx-in-memory-backend/dx-in-memory-backend.module";
import {HTTP_INTERCEPTORS} from "@angular/common/http";
import {DxLoggingInterceptor} from "./dx-core/interceptors/dx-logging-interceptor";
import {BdpkConfigService} from "./bdpk-common/services/bdpk-config.service";
import {PitNavigationModule} from "./pit-navigation/pit-navigation.module";
import {DxAuthModule} from "./dx-auth/dx-auth.module";
import {DxAuthStrategyType} from "./dx-auth/config/dx-auth-stategy-type";
import {DxAuthStorageStrategyType} from "./dx-auth/config/dx-auth-storage-strategy-type";
import {DxEncryptionStrategyType} from "./dx-core/config/dx-encryptions-type";
import {DxLogoutStrategyType} from "./dx-auth/config/dx-logout-strategy-type";
import {AppMocksProvider} from "./app-mocks.provider";
import {PitSharedModule} from "./pit-shared/pit-shared.module";
import {PitCommonModule} from "./pit-common/pit-common.module";
import {DX_API_MOCKS, DX_IN_MEMORY_BACKEND_CONFIG} from "./dx-in-memory-backend/config/dx-in-memory-backend-config";
import {DxModalsModule} from "./dx-modals/dx-modals.module";
import {DxAppRoutes} from "./dx-core/config/dx-app-routes";
import {DX_MODALS_CONFIG, DxModalsConfig} from "./dx-modals/config/dx-modals-config";
import {DxNciCoreModule} from "./dx-nci-core/dx-nci-core.module";
import {PitNciComboDatasource} from "./pit-shared/services/nci-combo/pit-nci-combo-datasource";
import {PitNciBackendComboDatasource} from "./pit-shared/services/nci-combo/pit-nci-backend-combo-datasource";
import {DxHttpErrorInterceptor} from "./dx-core/interceptors/dx-http-error-interceptor";
import {PitGridModalsService} from "./pit-shared/services/pit-grid-modals.service";
import * as moment from "moment";
import 'moment/locale/ru';
import momentDurationFormatSetup from "moment-duration-format";
import {MOMENT_DURATION_FORMAT_RU} from "./dx-core/utiles/dx-core-datetime-utils";
import {LocaleSpecification} from "moment";
import {DxNciService} from "./dx-nci-core/services/dx-nci.service";
import {DX_CORE_CONFIG} from "./dx-core/config/dx-core-config";
import {ActivatedRouteSnapshot, Router} from "@angular/router";
import {DxSessionService} from "./dx-auth/services/dx-session.service";


/**
 *  Фабричная функция для предоставления конфига приложения.
 *  используется как механизм загрузки настроект приложения перед его страпом.
 *  То есть, согласно логике работы APP_INITIALIZER, ее вызов блокирует загрузку приложения,
 *  до окончания выполнения тела функции.
 */
export function provideAppConfig(configProvider: BdpkConfigService, nciService: DxNciService, sessionService: DxSessionService): any {
  return async () => {
    try {
      sessionService.currentSession = await sessionService.storage.extract().toPromise();
    } catch (e) {
      // do nothing
    }
    // await nciService.fetchDictionaries(['type-file', 'plan-types']).toPromise();
    return configProvider.loadAppConfig();
  };
}

/** Фабричная функция для предоставления базовой части URL */
export function provideBaseLocation(configProvider: BdpkConfigService): string {
  return configProvider.baseUrl;
}

/**
 * Моки должны поставлять при помощи статичных фабричных функций
 * К сожению для lazy-load модулей придется забивать напрямую JSON.
 * Проблема в следующем:
 * Для использования статик-метода нужен класс, а для этого нужно импортировать модуль.
 * То есть он не должен быть lazy-load.
 * Момент второй импортрование InMemoryWebAPI в других модулях приводит к созданию нескольких
 * инстансов и путанице (Также как с HttpClient). Нужно и долго дебажить и разбираться как все развести.
 * Дабы не захламлять файл app.module я бы сделал отдельный класс со статик методами, который бы создавал
 * все моки.
 */
export function provideApiMocks(): Map<string, any[]> {
  return AppMocksProvider.provideAppMocks();
}


/** Фабричная функция для предоставления настроек модальных окон. */
export function provideModalsConfig(configProvider: BdpkConfigService): DxModalsConfig {
  return configProvider.bdpkModalsConfig;
}



/**
 * =====================================================================================================================
 *                                      !!!!!!!!!! АХТУНГ !!!!!!!!!!
 * =====================================================================================================================
 *
 * Основной принцип построения много-модульного приложения (в том числе с lazy-load модулями).
 *
 * Lazy-load модули имеют свой собственный инжектор, следовательно при загрузке каждого lazy-load модуля X
 * для ВСЕХ сервисов, импортированных транзитивно из модулей-зависимостей модуля X, будет создан новый инстас.
 *
 * Поэтому, все сервисы, которые должны быть system-wide или шарится между lazy-load модулями, должны быть вынесены
 * в отдельные shared-модули и имортироваться в рутовом модуля приложения. Тогда для создания инстансов этих сервисов
 * будет использован рутовый инжектор. Следовательно они будут везде в единственном экзепляре. Даже в lazy-load модулях.
 * И не нужно будет импортировать лишние модули в lazy-load модулях.
 *
 * Если модулю в целом используется уровне рута (Импортируется в рутовом модуле или в eager-модулях).
 * То выделять из него shared-часть не нужно. Просто импортируем его. Это работает, так как рутовый модуль
 * и eager-модули используют один и тотже инжектор.
 *
*        !!! ЭТО ОЧЕНЬ ВАЖДНЫЙ АРХИТЕКТУРНЫЙ НЮАНС И НУЖНО ЭТО УЧИТЫВАТЬ ПРИ ПРОЕКТИРОВАНИЕ ФУНКЦИОНАЛА МОДУЛЕЙ !!!
 *
 * =====================================================================================================================
 *
 *
 * Нюанс по использованию перехватчиков!
 * Тонкость состоит в том, что секция:
 *   ```
 *   {
 *     provide: HTTP_INTERCEPTORS,
 *     useClass: DxLoggingInterceptor,
 *     multi: true
 *   }
 *   ```
 * должна провайдится единожды в приложении. Даже упоминание ее сначала в `@NgModule` в секции `providers`, а
 * потом в секции `providers` внутри метода `forRoot(...)` приводит к созданию двух инстансов перехватчика!!
 * И, следовательно, к мультипликации `http`-запросов.
 *
 * С учетом того:
 * 1. Порядок применения перехватчиков обусловлен их порядком следования в секции `providers`
 * 2. Перехвачиков может быть много и из разных модулей
 *
 * оптимальная стратегия использования перехватчиков такова:
 * 1. Определяем нужные перехватчики в своих модулях (по-функциональности)
 * 2. Импортируем НУЖНЫЕ перехватчики только в РУТ-МОДУЛЕ в нужном порядке
 */
@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    DxCoreModule.forRoot(),
    DxInMemoryBackendModule,
    DxAuthModule.forRoot({
      authStrategyType: DxAuthStrategyType.SERVER_DEFINED,
      authStorageStrategyType: DxAuthStorageStrategyType.SERVER_STORAGE,
      logoutStrategyType: DxLogoutStrategyType.SYNC,
      loginRout: DxAppRoutes.LOGIN_ROUTE,
      logoutRout: DxAppRoutes.LOGIN_ROUTE
    }),
    DxModalsModule.forRoot(),
    DxNciCoreModule.forRoot(),
    PitCommonModule,
    PitSharedModule,
    PitNavigationModule
  ],
  providers: [
    {provide: LOCALE_ID, useValue: 'ru-RU' },
    {
      provide: ErrorHandler,
      useClass: DxErrorHandler
    },
    {
      provide: APP_INITIALIZER,
      useFactory: provideAppConfig,
      deps: [BdpkConfigService, DxNciService, DxSessionService],
      multi: true
    },
    {
      provide: APP_BASE_HREF,
      useFactory: provideBaseLocation,
      deps: [BdpkConfigService],
    },
    {
      provide: DX_IN_MEMORY_BACKEND_CONFIG,
      useValue: {
        env: environment
      }
    },
    {
      provide: DX_CORE_CONFIG,
      useValue: {
        env: environment,
        encryptionStrategyType: DxEncryptionStrategyType.BASIC,
        goBackRoute: DxAppRoutes.NAVIGATOR_ROUTE,
        errorRoute: DxAppRoutes.ERROR_ROUTE
      }
    },
    {
      provide: DX_API_MOCKS,
      useFactory: provideApiMocks,
      deps: [],
    },
    {
      provide: DX_MODALS_CONFIG,
      useFactory: provideModalsConfig,
      deps: [BdpkConfigService]
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: DxLoggingInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: DxHttpErrorInterceptor,
      multi: true
    },
    {
      provide: 'PIT_NCI_COMBO_DS',
      useClass: PitNciComboDatasource,
      multi: true
    },
    {
      provide: 'PIT_NCI_BACKEND_COMBO_DS',
      useClass: PitNciBackendComboDatasource,
      multi: true
    },
    {
      provide: 'PIT_GRID_MODAL_PROVIDER',
      useClass: PitGridModalsService,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule implements DoBootstrap {

  public static injector: Injector;

  constructor(private appRef: ApplicationRef,
              private injector: Injector,
              private router: Router) {

    AppModule.injector =  injector;

    const superShouldReuseRoute = this.router.routeReuseStrategy.shouldReuseRoute;
    this.router.routeReuseStrategy.shouldReuseRoute = (future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean => {
      return (future.url.length === 0 || future.queryParams.hash) ? false : superShouldReuseRoute(future, curr);
    };

    // setup Moment's locale
    moment.locale('ru');
    momentDurationFormatSetup(moment);
    moment.updateLocale('ru', MOMENT_DURATION_FORMAT_RU as LocaleSpecification);
  }

  ngDoBootstrap(appRef: ApplicationRef) {
  }
}

